export const SliderData = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/38242/pexels-photo-38242.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "SUMMER SALE",
    desc: "ALL PAST SEASON'S JACKETS UP TO 75% OFF!",
    cat: "jackets",
  },
  {
    id: 2,
    img: "https://i.ibb.co/xYGgC8y/2ndslide.png",
    title: "NEW GEAR",
    desc: "GEAR UP FOR WINTER NOW & SAVE UP TO 30% OFF NEW BOARDS!",
    cat: "boards",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/4678977/pexels-photo-4678977.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "STYLE UP",
    desc: "DON'T COMPROMISE ON STYLE! ALL PANTS UP TO 45% OFF!",
    cat: "pants",
  },
];

export const categories = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/7406838/pexels-photo-7406838.jpeg?auto=compress&cs=tinysrgb&w=600",
    title: "JACKETS",
    cat: "jackets",
  },
  {
    id: 2,
    img: "https://i.ibb.co/LRvm8j8/pexels-jo-l-super-2071654.jpg",
    title: "BOARDS",
    cat: "boards",
  },
  {
    id: 3,
    img: "https://www.burton.com/static/product/W23/10101109001_4.png?impolicy=bgwhite&imwidth=1586",
    title: "PANTS",
    cat: "pants",
  },
];
